<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<!-- 조회부분 시작 -->
			<div class="sf-col sf-col-9">
				<sf-card class="p-0 h-100 card_bg">
					<pc-clm-prs-search ref="search" :scrId="scrId"></pc-clm-prs-search>
				</sf-card>
			</div>
			<!-- 조회부분 끝 -->

			<!-- 그리드 부분 시작 -->
			<div class="sf-col sf-col-17">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<pc-clm-prs-table ref="table" @Refresh="Refresh" :scrId="scrId"></pc-clm-prs-table>
				</sf-card>
			</div>
			<!-- 그리드 부분 시작 -->
		</div>
	</div>
</template>

<script>
import PcClmPrsSearch from './Search/PcClmPrsSearch.vue';
import PcClmPrsTable from './Table/PcClmPrsTable.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {
		console.clear();
	},
	components: { PcClmPrsSearch, PcClmPrsTable },
	methods: {
		Refresh() {
			this.$refs.search.searchList();
		}
	}
};
</script>

<style></style>
